import React from 'react'
import './RealSolutions.css'
import msBalloonBridge from '../../img/ms-balloon-bridge.png'
import { Link } from 'react-router'
import {Button} from 'react-bootstrap'

const RealSolutions = (props) => {
  return (
    <div className="real-solutions-section">
      <img style={props.balloon} src={msBalloonBridge} className="second-balloon" alt="balloon" />
      <div className="real-solutions-content">
        <h1><span className="real-solutions-heading">Real Solution</span>s</h1>
        <p>Changing Mississippi&apos;s economic future will not be easy or quick and most of the standard solutions are merely wishful thinking. We&apos;re not done yet, but OLPI&apos;s research is helping to identify real solutions so that citizens and elected officials can make informed decisions to lift Mississippi out of last place.</p>

      <Link to={'/faqs'} className="link" >
        <Button bsSize="large" block className="CTA-button" >View our Frequently Asked Questions</Button>
      </Link>

      </div>

    </div>
  );
}

export default RealSolutions;



/** WEBPACK FOOTER **
 ** ./src/components/home/RealSolutions.js
 **/